module.exports = __webpack_public_path__ + "assets/img/home-huawei-light.6dfb7035.png";